import React, { useContext, useEffect, useState } from "react";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import companyDefault from "../../../images/resource/company-6.png";
import { clearSession, getSession } from "../../../utils/session";
import { EMPLOYR_LOGIN_SESSION } from "../../../constant/session";
import { get, post } from "../../../api";
import Scripts from "../../Common/Scripts/Scripts";
import { AuthContext } from "../../../context/auth";
import {
  formatDate,
  formatDateString,
  getTimeFromDate,
} from "../../../utils/date";
import { Chart, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import JobTags from "../Common/JobTags";
import Payout from "../Reports/Carehome/Payout";
Chart.register(ArcElement, Tooltip, Legend, Title);

export const calculateCompliancePercentage = (userDetail) => {
  let output = 0;
  const status1 =
    userDetail?.addressFirstLine &&
    userDetail?.firstName &&
    userDetail?.dob &&
    userDetail?.email &&
    userDetail?.photo &&
    userDetail?.status === "ACTIVE"
      ? 1
      : 0;
  const status2 = userDetail?.company?.sites?.length > 0 ? 1 : 0;
  const status3 =
    userDetail?.company?.subscription?.filter((itm) => itm?.status === "Active")
      ?.length > 0
      ? 1
      : 0;
  const status4 = userDetail?.company?.toaStatus > 0 ? 1 : 0;
  output = (status1 + status2 + status3 + status4) * 25;
  return Number(output);
};

const CareHome = () => {
  const [user, setUser] = useState();
  const [userDetail, setUserDetail] = useState();
  const [profileCompletionData, setProfileCompletionData] = useState();
  const [profilePercent, setProfilePercent] = useState(0);
  const [isLoading, setLoading] = useState(true);
  const { setFavourites, setProfilePic, setUnreadMessages } =
    useContext(AuthContext);
  const [stats, setStats] = useState();
  const [messages, setMessages] = useState([]);
  const [todayMeetings, setTodayMeetings] = useState([]);
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    setProfileCompletionData(null);
    const session = getSession(EMPLOYR_LOGIN_SESSION);
    setUser(session);
    const callMethod = async () => {
      const url = `/user/users/detail`;
      try {
        const response = await get(url);
        if (response) {
          setUserDetail(response);
          setProfilePic(response?.photo);
          setFavourites(response?.favourites?.length);
          const profilePercentage = calculateCompliancePercentage(response);
          setProfilePercent(profilePercentage);
          setProfileCompletionData({
            labels: ["Completed", "pending"],
            datasets: [
              {
                data: [profilePercentage, 100 - profilePercentage],
                backgroundColor: ["#f9ca0c", "rgb(204, 223, 243)"],
                borderWidth: 2,
              },
            ],
          });
          getActiveJobs(response?.company?.companyId);
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    };
    const getMessages = async () => {
      const url = `/message/messages?message-section=INBOX`;
      try {
        const response = await get(url);
        setMessages(response.slice(0, 10));
      } catch (e) {
        setLoading(false);
        console.log("error response", e);
      }
    };
    callMethod();
    getMessages();
    getStats();
    getTodaysMeetings();
  }, []);

  const getTodaysMeetings = async () => {
    const date = formatDate(new Date());
    try {
      const url = `/meeting-timesheet/meeting?date=${date}`;
      const response = await get(url);
      setTodayMeetings(response);
      console.log("response", response);
    } catch (e) {
      console.log(e);
    }
  };

  const getActiveJobs = async (companyId) => {
    setLoading(true);
    const url = `/job/jobs/company?companyId=${companyId}`;
    try {
      const response = await get(url);
      setJobs(response);
      setLoading(false);
    } catch (err) {
      console.log("Something Went Wrong", err);
    }
  };

  const sortByDate = messages?.sort(function (a, b) {
    return new Date(b.date) - new Date(a.date);
  });

  const getStats = async () => {
    const url = `/user/stats/count`;
    try {
      const response = await get(url);
      setStats(response);
      setUnreadMessages(response?.unreadMsg);
    } catch (e) {
      // console.log(e);
    }
  };
  const navigate = useNavigate();
  const logout = async (e) => {
    e?.preventDefault();
    const url = "user/users/logout";
    try {
      const response = await post(url, {});
      if (response?.status === 200) {
        clearSession(EMPLOYR_LOGIN_SESSION);
        navigate("/login");
      }
    } catch (e) {
      // console.log(e);
      if (e?.response?.data?.status === 498) {
        clearSession(EMPLOYR_LOGIN_SESSION);
        navigate("/login");
      }
    }
  };
  return (
    <>
      {/* <!-- Preloader --> */}
      {/* <div className="preloader"></div> */}
      {!isLoading && <Scripts />}
      <Header />
      {/* <!-- CareHome Sidebar --> */}
      {isLoading && <div className="preloader"></div>}
      <div className="user-sidebar">
        <div className="sidebar-inner">
          <ul className="navigation">
            <li className="active">
              <a href="/#/dashboard">
                {" "}
                <i className="la la-home"></i> Dashboard
              </a>
            </li>
            <li>
              <a href="/#/profile">
                <i className="la la-user-tie"></i>View Profile
              </a>
            </li>
            <li>
              <a href="/#/postjob">
                <i className="la la-paper-plane"></i>Post a New Job
              </a>
            </li>
            <li>
              <a href="/#/managejobs">
                <i className="la la-briefcase"></i> Manage Jobs{" "}
              </a>
            </li>
            <li>
              <a href="/#/applicants">
                <i className="la la-user-friends"></i> All Applicants
              </a>
            </li>
            <li>
              <a href="/#/reports">
                <i className="la la-chart-pie"></i>Reports
              </a>
            </li>
            <li>
              <a href="/#/messages">
                <i className="la la-envelope"></i>Messages
              </a>
            </li>
            <li>
              <a href="/#/meetings">
                <i className="la la-bell"></i>Meetings
              </a>
            </li>
            <li>
              <a href="/#/timesheet">
                <i className="la la-calendar-check"></i>Timesheets
              </a>
            </li>
            <li>
              <a href="/#/feedback">
                <i className="la la-sms"></i> Feedback
              </a>
            </li>
            <li>
              <a onClick={logout}>
                <i className="la la-sign-out"></i>Logout
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* <!-- End CareHome Sidebar --> */}
      <section className="user-dashboard">
        <div className="dashboard-outer">
          <div className="upper-title-box">
            <h3 className="capitalize">
              Welcome, {userDetail?.firstName} {userDetail?.lastName}
            </h3>
            <div className="text">Ready to jump back in?</div>
          </div>
          {/* <!--Carehome summary--> */}
          <div className="row">
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
              <div
                className="ui-item dashboard-box"
                onClick={(e) => {
                  e?.stopPropagation();
                  navigate("/managejobs");
                }}
              >
                <div className="left">
                  <i className="icon flaticon-briefcase"></i>
                </div>
                <div className="right">
                  <h4>{stats?.activeJobs ? stats.activeJobs : 0}</h4>
                  <p>Active Jobs</p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
              <div
                className="ui-item ui-red dashboard-box"
                onClick={(e) => {
                  e?.stopPropagation();
                  navigate("/managejobs");
                }}
              >
                <div className="left">
                  <i className="icon la la-file-invoice"></i>
                </div>
                <div className="right">
                  <h4>{stats?.closedJobs ? stats.closedJobs : 0}</h4>
                  <p>Closed Jobs</p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
              <div
                className="ui-item ui-yellow dashboard-box"
                onClick={(e) => {
                  e?.stopPropagation();
                  navigate("/applicants");
                }}
              >
                <div className="left">
                  <i className="icon la la-user"></i>
                </div>
                <div className="right">
                  <h4>{stats?.candidates ? stats.candidates : 0}</h4>
                  <p>Active Candidates</p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
              <div
                className="ui-item ui-green dashboard-box"
                onClick={(e) => {
                  e?.stopPropagation();
                  navigate("/messages");
                }}
              >
                <div className="left">
                  <i className="icon la la-envelope"></i>
                </div>
                <div className="right">
                  <h4>{stats?.messages ? stats.messages : 0}</h4>
                  <p>Messages</p>
                </div>
              </div>
            </div>
          </div>

          {/* <!--Alert for carehome and candidate--> */}
          {profilePercent !== 100 && (
            <div className="row">
              <div className="column col-lg-12 col-md-12 col-sm-12">
                <div className="message-box warning">
                  <p>
                    Profile is not complete. Please complete it to be able to
                    post jobs.
                  </p>
                  <button className="close-btn">
                    <span className="close_icon"></span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* <!--carehome checklist--> */}
          <div className="row">
            <div className="col-lg-5">
              <div className="notification-widget ls-widget">
                <div className="tabs-box">
                  <div className="widget-title">
                    <h4>Profile Completion {profilePercent}%</h4>
                  </div>
                  <div className="widget-content skills-percentage">
                    <div className="pie-graph">
                      <div className="graph-outer">
                        {profileCompletionData && (
                          <Doughnut data={profileCompletionData} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="notification-widget ls-widget">
                <div className="tabs-box">
                  <div className="widget-title">
                    <h4>Checklist</h4>
                  </div>
                  <div className="widget-content">
                    <div className="table-outer">
                      <table className="default-table">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Item</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            {userDetail?.addressFirstLine &&
                            userDetail?.firstName &&
                            userDetail?.dob &&
                            userDetail?.email &&
                            userDetail?.photo &&
                            userDetail?.status === "ACTIVE" ? (
                              <td className="completed">
                                <span className="la la-check white"></span>
                              </td>
                            ) : (
                              <td className="notcompleted">
                                <span className="la la-times white"></span>
                              </td>
                            )}
                            <td>Profile</td>
                            <td>
                              {userDetail?.addressFirstLine &&
                              userDetail?.firstName &&
                              userDetail?.dob &&
                              userDetail?.email &&
                              userDetail?.photo &&
                              userDetail?.status === "ACTIVE"
                                ? "Completed"
                                : "Not Completed"}
                            </td>
                            <td>
                              <div className="option-box">
                                <ul className="option-list">
                                  <li>
                                    <a href="#/profile" data-text="Update">
                                      <span className="la la-pencil"></span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            {userDetail?.company?.sites?.length > 0 ? (
                              <td className="completed">
                                <span className="la la-check white"></span>
                              </td>
                            ) : (
                              <td className="notcompleted">
                                <span className="la la-times white"></span>
                              </td>
                            )}
                            <td>Number of Sites</td>
                            <td>{userDetail?.company?.sites?.length || 0}</td>
                            <td>
                              <div className="option-box">
                                <ul className="option-list">
                                  <li>
                                    <a
                                      href="#/profile?tab=sites"
                                      data-text="Update"
                                    >
                                      <span className="la la-pencil"></span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            {userDetail?.company?.subscription?.filter(
                              (itm) => itm?.status === "Active"
                            ) ? (
                              <td className="completed">
                                <span className="la la-check white"></span>
                              </td>
                            ) : (
                              <td className="notcompleted">
                                <span className="la la-times white"></span>
                              </td>
                            )}
                            <td>Subscription</td>
                            <td>
                              {userDetail?.company?.subscription?.filter(
                                (itm) => itm?.status === "Active"
                              )[0]?.subscription || ""}
                            </td>
                            <td>
                              <div className="option-box">
                                <ul className="option-list">
                                  <li>
                                    <a
                                      href="#/profile?tab=subscription"
                                      data-text="Update"
                                    >
                                      <span className="la la-pencil"></span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            {userDetail?.company?.toaStatus ? (
                              <td className="completed">
                                <span className="la la-check white"></span>
                              </td>
                            ) : (
                              <td className="notcompleted">
                                <span className="la la-times white"></span>
                              </td>
                            )}
                            <td>Terms of Agreement</td>
                            <td>
                              {userDetail?.company?.toaStatus
                                ? "Signed"
                                : "Not Signed"}
                            </td>
                            <td>
                              <div className="option-box">
                                <ul className="option-list">
                                  <li>
                                    <a
                                      href="#/profile?tab=toa"
                                      data-text="Update"
                                    >
                                      <span className="la la-pencil"></span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!--Today Meeting --> */}
          <div className="row">
            <div className="col-lg-12">
              {/* <!-- Graph widget --> */}
              <div className="graph-widget ls-widget">
                <div className="tabs-box">
                  <div className="widget-title">
                    <h4>Today's Meetings</h4>
                  </div>

                  <div className="widget-content">
                    <div className="table-outer">
                      <table className="default-table manage-job-table">
                        <thead>
                          <tr>
                            <th>Action</th>
                            <th>Meeting Time</th>
                            <th>Candidate Name</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {todayMeetings?.length === 0 && (
                            <tr>
                              <td>No Meetings Found !!</td>
                            </tr>
                          )}
                          {todayMeetings?.map((itm) => (
                            <tr>
                              <td
                                style={{
                                  paddingLeft: "0",
                                }}
                              >
                                <div className="option-box">
                                  <ul className="option-list">
                                    <li>
                                      <a data-text="View" href={"/#/meetings"}>
                                        <span className="la la-eye"></span>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                              <td>
                                {/* <h6>{itm?.meetingDate}</h6> */}
                                <span className="info">
                                  <i className="icon flaticon-clock"></i>{" "}
                                  {getTimeFromDate(itm?.meetingDateTime)}
                                </span>
                              </td>
                              <td>{itm?.toUserName}</td>
                              <td>{itm?.status}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <!--carehome chart--> */}
          <div className="row">
            <div className="col-lg-12">
              {/* <!-- Graph widget --> */}
              <div className="graph-widget ls-widget">
                <div className="tabs-box">
                  <Payout />
                </div>
              </div>
            </div>
          </div>

          {/* <!--carehome notification--> */}
          <div className="row">
            <div className="col-lg-5">
              {/* <!-- Notification Widget --> */}
              <div className="notification-widget ls-widget">
                <div className="widget-title">
                  <h4>Notifications</h4>
                  <div className="chosen-outer">
                    {/* <!--Tabs Box--> */}
                    <button
                      onClick={(e) => {
                        e?.stopPropagation();
                        navigate("/messages");
                      }}
                      className="theme-btn btn-style-three"
                    >
                      View all
                    </button>
                  </div>
                </div>
                <div className="widget-content">
                  <ul className="notification-list">
                    {sortByDate?.map((item) => {
                      return (
                        item?.toId === userDetail?.userId && (
                          <li key={item?.messageId}>
                            <span className="icon flaticon-briefcase"></span>{" "}
                            <strong>{`${item?.message} from ${item?.fromFullName}`}</strong>{" "}
                            {/* <span className="colored">Web Developer</span> */}
                          </li>
                        )
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              {/* <!-- applicants Widget --> */}
              <div className="applicants-widget ls-widget">
                <div className="widget-title">
                  <h4>Recent Jobs</h4>
                  <div className="chosen-outer">
                    {/* <!--Tabs Box--> */}
                    <button
                      onClick={(e) => {
                        e?.stopPropagation();
                        navigate("/appliedjobs");
                      }}
                      className="theme-btn btn-style-three"
                    >
                      View all
                    </button>
                  </div>
                </div>
                <div className="widget-content">
                  <div className="row">
                    {/* <!-- Job Block --> */}
                    {jobs?.map((job) => {
                      return (
                        <div
                          className="job-block col-lg-12 col-md-12 col-sm-12"
                          key={job?.id}
                        >
                          <div className="inner-box">
                            <div className="content">
                              <span className="company-logo">
                                <img
                                  src={
                                    job?.companyPhoto
                                      ? job?.companyPhoto
                                      : companyDefault
                                  }
                                  alt=""
                                />
                              </span>
                              <h4>
                                <a href="#">{job?.title}</a>
                              </h4>
                              <ul className="job-info">
                                {/* <li>
                              <span className="icon flaticon-briefcase"></span>{" "}
                              Segment
                            </li> */}
                                <li>
                                  <span className="icon flaticon-map-locator"></span>{" "}
                                  {job?.siteCity}
                                </li>
                                <li>
                                  <span className="icon flaticon-clock-3"></span>{" "}
                                  Closing Date: {formatDateString(job?.endDate)}
                                </li>
                                <li>
                                  <span className="icon flaticon-money"></span>£
                                  {job?.ratePerHour} per hour
                                </li>
                              </ul>
                              <JobTags endDate={job?.endDate} job={job} />
                              <button className="bookmark-btn">
                                <span className="flaticon-bookmark"></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default CareHome;
